import {AddSchema} from "mobx-graphlink";
import {TriggerSet} from "../@TriggerSet.js";
import {EffectPointer} from "../../@Shared/EffectPointer.js";
import {GetValues_ForSchema} from "js-vextensions";
import {EngineConfigVariant} from "./@Shared/EngineConfigVariant.js";

export class EngineConfig_Variants {
	constructor(data: Partial<EngineConfig_Variants>) { Object.assign(this, data); }

	variants: EngineConfigVariant[];
}
AddSchema("EngineConfig_Variants", {
	properties: {
		variants: {items: {$ref: "EngineConfigVariant"}},
	},
});